import { ReactElement } from 'react'
import styles from './MobileContactScreen.module.scss'
import { MobileBodyLarge, MobileHeadlineLarge } from '../../Typography'
import { ContactForm } from '../../components/contact-form/ContactForm'

export const MobileContactScreen = (): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.wideColumn}>
        <MobileHeadlineLarge>Kontakt</MobileHeadlineLarge>
        <div className={styles.tightColumn}>
          <MobileBodyLarge>
            Du hast Fragen oder Anregungen rund ums Thema FIGHTBACK-WRESTLING?
          </MobileBodyLarge>
          <MobileBodyLarge>
            Du hast Feedback zur Website, oder zu FIGHTBACK-WRESTLING allgemein?
          </MobileBodyLarge>
          <MobileBodyLarge>
            Du möchtest selbst Wrestler werden und dich für ein Probetraining anmelden oder generell
            ein Teil der FIGHTBACK-Crew in Form von Ringrichter, Kameramann, Media-Team oder
            sonstigem werden?
          </MobileBodyLarge>
          <MobileBodyLarge>
            Dann melde dich gerne über unser Kontaktformular oder sende uns direkt eine E-Mail an{' '}
            <a className={styles.emailLink} href={'mailto:office@fightback-wrestling.com'}>
              office@fightback-wrestling.com
            </a>
          </MobileBodyLarge>
        </div>
      </div>
      <ContactForm />
    </div>
  )
}
